module.exports = __webpack_public_path__ + "img/ico_alojamiento.bc4121aa.svg";